import smartParkService from "../axios";

export const fieldsService = async (parkid, payloadObj) => {
    return await (await smartParkService.get('api/park/' + parkid + '/fields')).data;
}